import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Formik, Form as FormikForm } from "formik";
import { toast } from "react-toastify";
import axios from "../../axios";
import { API_CALL_URL_PRIVATE, DOMAIN_URL } from "../../constants/compensate";
import Texterror from "../Texterror";
import { StaffingGridCalculateValidation } from "../../utils/validator";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

function EditReasonMaster() {
  const fileInputRef = useRef(null);
  const fileLogoInputRef = useRef(null);
  const { ID, CostCenterID } = useParams();
  const dispatch = useDispatch();
  console.log(ID);
  const navigate = useNavigate();
  const customer_code = useSelector((state) => state.compensate.customerCode);
  const loading_page = useSelector((state) => state.compensate.LoadingPage);
  const [isLoading, setIsLoading] = useState(false);
  const [FormInitialData, setFormInitialData] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [initialImageUrl, setInitialImageUrl] = useState(null);
  const [initialIconUrl, setInitialIconUrl] = useState(null);
  const [isInitialData, setISInitialData] = useState(false);
  const [isCostData, setIsCostData] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [fieldConfig, setFieldConfig] = useState([]);
  const [costCenterMaster, setCostCenterMaster] = useState(null);
  const [dropCostCenterMaster, setDropCostCenterMaster] = useState([]);


  useEffect(() => {
    const getInitalData = async () => {
      const resp = await axios.post(
        `${API_CALL_URL_PRIVATE}/staffingGridCalculated/view`,
        {
          // _id: ID,
          customer_code: parseInt(customer_code),
          cost_center_number: CostCenterID,
        }
      );

      const fieldsFromAPI = resp?.data?.data?.patient_fields;

      const newInitialValues = {};
      const touchedFields = {};
      fieldsFromAPI.forEach((item) => {
        newInitialValues[item.field_name] = item.value;
        touchedFields[item.field_name] = true;
      });
      
      setFieldConfig(resp?.data?.data);
      setInitialValues(newInitialValues);

      setISInitialData(true);
    };
    getInitalData();
  }, [ID]);

  const onSubmit = (values, onSubmittingProps) => {
    console.log("form Values", values);
    formSubmit(values);
  };
  const formSubmit = async (values) => {
    const obj = {
      _id: ID,
      customer_code: parseInt(customer_code),
      cost_center_number: CostCenterID,
      ...values,
    };

    try {
      setIsLoading(true);
      const resp = await axios.post(
        `${API_CALL_URL_PRIVATE}/staffingGridCalculated/create`,
        obj
      );
      console.log(resp);
      toast.success(resp?.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
      // navigate("/admin/location-master");
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });

      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  console.log("initialValues", initialValues);
  
  
  return (
    <>
      {isInitialData ? (
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
            validate={(values) =>
                     StaffingGridCalculateValidation(values, fieldConfig?.patient_fields, true)
                   }
          enableReinitialize
          validateOnChange
        >
          {(formik) => {
            return (
              <div className="main-panel">
                {console.log(formik)}
                <div className="content-wrapper">
                  <div className="page-header">
                    <h3 className="page-title">
                      <a href="#" className="badge badge-dark"></a>
                    </h3>
                    <div className></div>
                  </div>
                  <div className="row">
                    <div class="col-12 grid-margin stretch-card">
                      <div class="card">
                        <FormikForm className="forms-sample">
                          <div class="card-body">
                            <div className="row align-items-center">
                              <div className="col-3">
                                <Link
                                  to={`/admin/staffing-grid-calculated`}
                                  className="f-14 white-text-dark-mode"
                                >
                                  <FontAwesomeIcon icon="fa-solid fa-arrow-left " />{" "}
                                  Back
                                </Link>
                              </div>
                              <div className="col-6">
                                <h4 class="card-title text-center">
                                  {`Updating details for ${fieldConfig?.cost_center_details?.cost_center_name} - ${fieldConfig?.cost_center_details?.cost_center_number}`}
                                </h4>
                              </div>
                              {/* <div className="col-3 text-end">
                              <Button
                                className="ms-3"
                                variant="success"
                                type="submit"
                                disabled={isLoading}
                              >
                                {isLoading ? "Saving..." : "Save"}
                              </Button>
                            </div> */}
                            </div>

                            <div class="row">
                              {fieldConfig?.patient_fields?.map((field) => (
                                <Form.Group
                                  key={field.field_name}
                                  className="col-md-2 mb-3"
                                  controlId={`field-${field.field_name}`}
                                >
                                  <OverlayTrigger
                                    key={"top"}
                                    placement={"top"}
                                    overlay={
                                      <Tooltip id={`tooltip-${"top"}`}>
                                        <strong>{field?.field_name}</strong>
                                      </Tooltip>
                                    }
                                  >
                                    <Form.Label>{field.field_label}</Form.Label>
                                  </OverlayTrigger>
                                  <Form.Control
                                    type="number"
                                    placeholder=""
                                    name={field.field_name}
                                    {...formik.getFieldProps(field.field_name)}
                                  />
                                  <ErrorMessage
                                    name={field.field_name}
                                    component={Texterror}
                                  />
                                </Form.Group>
                              ))}
                              <Form.Group className="col-md-12 mb-3 d-flex justify-content-end">
                                {/* <Button
                              variant="primary"
                              type="button"
                              onClick={() => {
                                formik.resetForm();
                                setSelectedImage(null);
                                // const fileInput =
                                //   document.getElementById("logo");
                                // if (fileInput) {
                                //   fileInput.value = "";
                                // }
                              }}
                            >
                              Reset
                            </Button> */}
                                <Button
                                  className="ms-3"
                                  variant="success"
                                  type="submit"
                                  disabled={isLoading}
                                >
                                  {isLoading ? "Saving..." : "Save"}
                                </Button>
                              </Form.Group>
                            </div>
                          </div>
                        </FormikForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }}
        </Formik>
      ) : (
        <div className="d-flex align-items-center justify-content-center w-100vw h-100vh">
          <span class="loader" style={{ width: "50px", height: "50px" }}></span>
        </div>
      )}
    </>
  );
}

export default EditReasonMaster;
